import styled from 'styled-components';

export const PageHeaderSC = styled.div<{ showDivider?: boolean; hasFooter?: boolean }>`
  background: ${({ theme }) => theme.color.surface.baseline};
  padding-top: ${({ theme }) => theme.spacings.component.XS}px;
  padding-bottom: ${({ theme, hasFooter }) => (hasFooter ? 0 : theme.spacings.component.M)}px;
  border-bottom: ${({ showDivider, theme }) =>
    showDivider ? `1px solid ${theme.color.border.emphasis}}` : 'none'};

  .header-breadcrumbs {
    padding-left: 12px;
  }

  .header-heading {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;

    .header-title-wrapper {
      display: flex;
      flex-direction: row;

      margin-right: 16px;
      color: ${({ theme }) => theme.color.tint.primary};
      ${({ theme }) => theme.mappedTypography.h3.default};

      .header-title-extra {
        white-space: nowrap;
      }

      .header-title-subtitle {
        ${({ theme }) => theme.mappedTypography.h6.default};
        color: ${({ theme }) => theme.color.tint.secondary};
        padding-top: 8px;
      }

      .header-title-back {
        width: 40px;
        height: 40px;

        display: flex;
        align-items: center;
        justify-content: center;
        /* padding: 8px; */
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
      }
    }
  }

  .header-content {
    padding-top: 12px;
  }

  .header-footer {
    margin-top: 16px;

    .ui-tabs {
      .rc-tabs-nav {
        border-bottom: none;
      }
    }
  }
`;
